
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class TaxDialog extends Serenity.EntityDialog<TaxRow, any> {
        protected getFormKey() { return TaxForm.formKey; }
        protected getIdProperty() { return TaxRow.idProperty; }
        protected getLocalTextPrefix() { return TaxRow.localTextPrefix; }
        protected getNameProperty() { return TaxRow.nameProperty; }
        protected getService() { return TaxService.baseUrl; }
        protected getDeletePermission() { return TaxRow.deletePermission; }
        protected getInsertPermission() { return TaxRow.insertPermission; }
        protected getUpdatePermission() { return TaxRow.updatePermission; }

        protected form = new TaxForm(this.idPrefix); 

        constructor() {
            super();

            this.form.ApplicableOn.changeSelect2(e => {
                if (this.form.ApplicableOn.value == "Product") {
                    Serenity.EditorUtils.setReadOnly(this.form.ProductType, false);
                    
                    if (this.form.CalculatingMode.value == "Tax Amount") {
                        //Serenity.EditorUtils.setReadOnly(this.form.ItemDetails, false);
                        //this.form.ItemDetails.EnableAddButton();
                    }
                } else {
                    Serenity.EditorUtils.setReadOnly(this.form.ItemDetails, true);
                    Serenity.EditorUtils.setReadOnly(this.form.ProductType, true);
                    this.form.ItemDetails.DisableAddButton();
                    this.form.ProductType.value="";
                }
            });
            this.form.CalculatingMode.changeSelect2(e => {
                if (this.form.CalculatingMode.value == "Tax Amount") {
                    if (this.form.ApplicableOn.value == "Product") {
                        //Serenity.EditorUtils.setReadOnly(this.form.ItemDetails, false);
                        //this.form.ItemDetails.EnableAddButton();
                    }
                } else {
                    //Serenity.EditorUtils.setReadOnly(this.form.ItemDetails, true);
                    //this.form.ItemDetails.DisableAddButton();
                }
            });
            this.form.TaxType.changeSelect2(e => {
                if (this.form.TaxType.value == "CESS") {
                    this.form.ApplicableOn.set_value("Product");
                    this.form.CalculatingMode.set_value("Tax Amount");
                    Serenity.EditorUtils.setReadOnly(this.form.ApplicableOn, true);
                    Serenity.EditorUtils.setReadOnly(this.form.CalculatingMode, true);
                    Serenity.EditorUtils.setReadOnly(this.form.ItemDetails, false);
                    this.form.ItemDetails.EnableAddButton();
                } else {

                    this.form.ApplicableOn.set_value("Bill");
                    this.form.CalculatingMode.set_value("Bill Amount");
                    Serenity.EditorUtils.setReadOnly(this.form.ApplicableOn, false);
                    Serenity.EditorUtils.setReadOnly(this.form.CalculatingMode, false);
                    Serenity.EditorUtils.setReadOnly(this.form.ItemDetails, true);
                    this.form.ItemDetails.DisableAddButton();
                }
            });

            this.form.HasThreshold.changeSelect2(e => {
                if (this.form.HasThreshold.value == true) {
                    Serenity.EditorUtils.setReadOnly(this.form.SingleTrans, false);
                    Serenity.EditorUtils.setReadOnly(this.form.CumulativeTrans, false);


                } else {
                    Serenity.EditorUtils.setReadOnly(this.form.SingleTrans, true);
                    Serenity.EditorUtils.setReadOnly(this.form.CumulativeTrans, true);
                }
            });

            this.form.TaxName.changeSelect2(e => {
                var id = TaxRow.getLookup().items.filter(x => x.TaxName.toUpperCase() == this.form.TaxName.value.toUpperCase())[0];
                if (id.TaxId != null || id.TaxId > 0) {
                    Q.notifyError("Duplicate Tax Code " + this.form.TaxName.value);
                    this.form.TaxName.value = "";
                    return;
                }
                else {
                    this.form.TaxName.value = this.form.TaxName.value.toUpperCase();
                }
            })

        }
        protected onDialogOpen() {
            if (this.form.ApplicableOn.value == "Product") {
                Serenity.EditorUtils.setReadOnly(this.form.ProductType, false);

                if (this.form.CalculatingMode.value == "Tax Amount") {
                    //Serenity.EditorUtils.setReadOnly(this.form.ItemDetails, false);
                    //this.form.ItemDetails.EnableAddButton();
                }
            } else {
                Serenity.EditorUtils.setReadOnly(this.form.ItemDetails, true);
                Serenity.EditorUtils.setReadOnly(this.form.ProductType, true);
                this.form.ItemDetails.DisableAddButton();
            }
        } 
    }
}